var _defs, _polygon, _polygon2, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotchpocket01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-82,.cls-81{fill:#fff;stroke:#010101;stroke-miterlimit:10;}.cls-82{stroke-width:2.88px;}.cls-81{stroke-dasharray:3;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "342.42 179.43 342.42 384.05 213.88 420.46 80.58 384.05 80.58 179.43 342.42 179.43"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "83.58 381.76 83.58 182.43 339.42 182.43 339.42 381.78 213.86 417.34 83.58 381.76"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 80.59,
    y: 130.13,
    width: 261.83,
    height: 49.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 83.58,
    y: 133.13,
    width: 255.83,
    height: 43.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotchpocket01);
export default __webpack_public_path__ + "static/media/NOTCH POCKET-01.80a675ec1208be091083b6213326773c.svg";
export { ForwardRef as ReactComponent };